import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'universal-cookie';
import { ProfileCredentials, ProfileInfo } from "../types/Types";
import { set } from "react-hook-form";


/**
 * @author noone
 */

export type AuthState = {
    credentials: ProfileCredentials | undefined
    user: ProfileInfo | undefined,
    isAuthenticated: boolean,
    token: string | undefined,
    isAuthCheckFinished: boolean,
    enteredResetMailAddress: string | undefined,
}

export type IToken = {
    uid: string,
    is2fa: false,
    username: string,
    iat: number,
    exp: number,
    rollen: string[]
}

const initialState = {
    credentials: undefined,
    user: undefined,
    isAuthenticated: false,
    isAuthCheckFinished: false,
    token: undefined,
    enteredResetMailAddress: undefined,
    username: undefined,
} as AuthState;

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setLogin(state, action: PayloadAction<ProfileInfo>) {
            state.isAuthenticated = true;
            state.isAuthCheckFinished = true;
            state.user = action.payload;
        },
        setLogout(state) {
            state.credentials = undefined;
            state.user = undefined;
            state.token = undefined;
            state.isAuthenticated = false;

            localStorage.removeItem('token');

            const cookies = new Cookies();
            cookies.remove('token', { path: '/', secure: true, httpOnly: false, sameSite: "none" });
        },
        setCredentials(state, action: PayloadAction<ProfileCredentials>) {
            state.credentials = action.payload;
        },
        setToken(state, action: PayloadAction<string>) {
            localStorage.setItem('token', action.payload);
            state.token = action.payload;
        },
        setEnteredResetMailAddress(state, action: PayloadAction<string>) {
            state.enteredResetMailAddress = action.payload;
        },
        setAuthCheckFinished(state, action: PayloadAction<boolean>) {
            state.isAuthCheckFinished = action.payload;
        }
    }
});

export const {
    setLogin
    , setLogout
    , setCredentials
    , setToken
    , setEnteredResetMailAddress
    , setAuthCheckFinished
} = authSlice.actions;

export default authSlice;


